// Inline SVG icon set for Brand Protection tabs.
// Usage: <Icon name="shield" size={16} color="#2563eb" />
import React from 'react';

const PATHS = {
    alert:   'M12 2L2 19h20L12 2zm0 3.5L19.5 18h-15L12 5.5zM11 10v4h2v-4h-2zm0 6v2h2v-2h-2z',
    shield:  'M12 1L3 5v6c0 5.25 3.75 10.15 9 11.25C17.25 21.15 21 16.25 21 11V5l-9-4zm0 2.18l7 3.11V11c0 4.1-2.93 7.93-7 9.07C7.93 18.93 5 15.1 5 11V6.29l7-3.11z',
    chevron: 'M10 6L8.59 7.41 13.17 12 8.59 16.59 10 18l6-6-6-6z',
    clock:   'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67V7z',
    bell:    'M12 22c1.1 0 2-.9 2-2h-4c0 1.1.9 2 2 2zm6-6v-5c0-3.07-1.63-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.64 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2z',
    check:   'M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z',
    filter:  'M10 18h4v-2h-4v2zm-7-1v2h4v-2H3zM3 6v2h14V6H3zm0 7h10v-2H3v2zm14-1v2h4v-2h-4zm0 5h4v-2h-4v2z',
    flag:    'M14.4 6L14 4H5v17h2v-7h5.6l.4 2h7V6h-5.6z',
    globe:   'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z',
};

export function Icon({ name, size = 16, color = 'currentColor', style, className }) {
    const d = PATHS[name];
    if (!d) return null;
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill={color}
            style={{ display: 'inline-block', verticalAlign: 'middle', flexShrink: 0, ...style }}
            className={className}
            aria-hidden="true"
        >
            <path d={d} />
        </svg>
    );
}
